import { render, staticRenderFns } from "./CreatePotentialModal.vue?vue&type=template&id=bad716a8"
import script from "./CreatePotentialModal.vue?vue&type=script&lang=js"
export * from "./CreatePotentialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports